import { Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { AuthService } from "../../../services/auth.service";
import { FormArray, FormControl, FormGroup } from '@angular/forms';
import { ApiService } from "../../../services/api.service";
import { NavController, TextInput } from "ionic-angular";
import { UserGroupService } from "../../../services/user-group.service";
import { EventService } from "../../../services/event.service";
import { IonicHelper } from "../../../helpers/ionic.helper";
import { UserService } from "../../../services/user.service";
import { FormHelper } from "../../../helpers/form.helper";
import { CategoryService } from '../../../services/category.service';
import { TagService } from '../../../services/tag.service';
import { ButtonStyle } from '../../upload/file-upload';


@Component({
  selector: 'post-create',
  templateUrl: 'post-create.html'
})

export class PostCreate implements OnInit {

	@Output() createPostOpen: EventEmitter<boolean> = new EventEmitter<boolean>();

  showPopup: boolean = false;
  form: FormGroup;
  buttonStyleButton = ButtonStyle.Button;

	@ViewChild('titleInput') titleInput: TextInput;

  constructor(private formHelper: FormHelper,
  						public authService: AuthService,
							public userGroupService: UserGroupService,
							public categoryService: CategoryService,
							public tagService: TagService,
							private nav: NavController,
							private apiService: ApiService,
							private ionic: IonicHelper,
							private eventService: EventService,
              private userService: UserService
	) {
		        
  	
  	eventService.showNewPostDialog.subscribe(() => {
  		this.togglePopup(true);
		});
    
  }
  
  ngOnInit(): void {
  	this.formHelper.buildPostForm().then((form) => {
  		this.form = form;
		});

		this.eventService.closePostCreateCard.subscribe((close) => {
			this.togglePopup(!close);
		});
	}
	
  
  
  togglePopup(activate): void {
		this.showPopup = activate;
		
		this.eventService.toggleTabBar.emit(!activate);

		this.createPostOpen.emit(activate);
		
		if(activate) {
			setTimeout(() => {
				if(this.titleInput) this.titleInput.setFocus();
			},50);
		}
  }
  
  submitForm(): void {
		this.ionic.toggleLoader(true);

		if(this.form.valid){

    	let newPost = FormHelper.createObjectFromFormValues(this.form, {
    		userGroups: this.userGroupService.userGroups,
    		categories: this.categoryService.categories
    	});
    	
			this.apiService.createResource('posts', newPost).then((post) => {
				this.nav.push('post', {postId: post.id});

				this.ionic.toggleLoader(false);
				this.togglePopup(false);
	      this.ionic.toast('POST.PLACED');

				//Reload user stats
				this.userService.reloadAuthenticatedUser();

				//Reload usergroups and categories to update stats..bit overkill but okay for now
        this.userGroupService.loadUserGroups();
        this.categoryService.loadCategories();

        this.eventService.reloadPosts.emit();

        this.clearForm();

			}).catch((err) => {
				console.error(err);
        this.ionic.toggleLoader(false);
        this.ionic.alert('GLOBAL.GENERAL_ERROR');
			});
		}
		else {
      this.ionic.toggleLoader(false);   
    	this.ionic.invalidFieldsAlert(
    		'POST_CREATE.ERROR',
				'POST_CREATE.TRY_AGAIN',
				'POST_CREATE.ERRORS',
				FormHelper.getInvalidFormControls(this.form.controls)    		
			);
		}
    
  }
  
  clearForm(): void {
    this.form.setControl('attachments', new FormArray([]));
    let attachmentControls = this.form.get('attachments') as FormArray;   
    let newFormControl = new FormControl();
    attachmentControls.push(newFormControl);  
    
    this.form.reset();
  }

	addAttachmentField(): void {    
    let newFormControl = new FormControl(null);
    let attachmentControls = this.form.get('attachments') as FormArray;
    attachmentControls.push(newFormControl);
  }
	
  attachmentUploadError(ev){
    this.ionic.alert('POST_CREATE.ADD_ATTACHMENT_ERROR');
  }
  
	removeAttachmentField(i): void {
    (this.form.get('attachments') as any).removeAt(i);
  }
}




// WEBPACK FOOTER //
// ./src/partials/post/post-create/post-create.ts